import { UppClientOptions } from '../client/interfaces'
import { CHILD_TIMEOUT_ANDROID, CHILD_TIMEOUT_DEFAULT, CHILD_TIMEOUT_MOBILE } from '../config'

export type TimeoutOptions = Pick<UppClientOptions, 'section' | 'forceContent' | 'contentGroup'>

export function getTimeout(options?: TimeoutOptions): number {
  if (options?.section?.startsWith('app_and') && options?.forceContent || options?.contentGroup) {
    return CHILD_TIMEOUT_ANDROID
  }

  const isMobileDevice: boolean = ('ontouchstart' in document.documentElement) || false;
  return isMobileDevice ? CHILD_TIMEOUT_MOBILE : CHILD_TIMEOUT_DEFAULT;
}
